import React, { Fragment, useEffect, useMemo, useState } from "react";
import {
  Typography,
  Container,
  Button,
  CircularProgress,
  Modal,
  Stack,
  debounce,
} from "@mui/material";
import readXlsxFile from "read-excel-file";
import { CSVReader } from "react-papaparse";
import writeXlsxFile from "write-excel-file";

import { makeStyles } from "@mui/styles";

import { backend, API_URL } from "../../../config";
import { Link } from "react-router-dom";

import { useSelector } from "react-redux";

import OrderlistCategories from "../components/UIs/OrderlistCategories";
import OrderlistProducts from "../components/UIs/OrderlistProducts";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export const CustomerOrderlists = (props) => {
  const classes = useStyles();

  const customerId = props.match.params.id;
  const currentUserStore = useSelector((state) => state.current_user);

  const [customer, setCustomer] = useState({
    id: "",
    name: "",
    company_id: "",
    company_location: [],
    company_location_id: [],
    fees: [],
    margins: [],
    surcharges: [],
  });
  const [customerLoaded, setCustomerLoaded] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [orderListLoaded, setOrderListLoaded] = useState(false);
  const [categorySettings, setCategorySettings] = useState({
    name: "",
    company_location: "",
    orderlist: "",
    category: "",
    product: null,
    include_inactive: false,
    include_nonprimary: false,
  });
  const [orderListSettings, setOrderListSettings] = useState([]);
  const [categoryListSettings, setCategoryListSettings] = useState([]);
  const [importingModal, setImportingModal] = useState(false);
  const [importedData, setImportedData] = useState([]);
  const [importedDataImported, setImportedDataImported] = useState(false);
  const [importedOrderList, setImportedOrderList] = useState([]);
  const [exportingModal, setExportingModal] = useState(false);
  const [olProductMissing, setOlProductMissing] = useState(true);
  const [orderListNav, setOrderListNav] = useState(0); // 0 = categories | 1 = products
  const [products, setProducts] = useState([]);
  const [orderListMapped, setOrderListMapped] = useState(false);

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to save the customer
          <b>{` ${customer.name}?`}</b>
          {orderList.length && olProductMissing ? (
            <>
              <Typography style={{ color: "red" }}>
                <br />
                <b>Warning: </b> There might be some Order Guide items missing.
                You can identify them by the wording:
                <b> undefined (undefined).</b>
              </Typography>
            </>
          ) : (
            <br />
          )}
          <br />
          <div align="right">
            <Button onClick={() => toggleConfirmModal()}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Saving customer information <br />
              This may take some time relative to the number of categories and
              fees configured
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while saving the customer information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveError()}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          Customer information have been successfully saved
          <br />
          <br />
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const toggleImportingModal = () => setImportingModal(!importingModal);

  const importingFormat = () => (
    <table border="1">
      <thead>
        <tr>
          <th></th>
          <th>A</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Category 1</td>
        </tr>
        <tr>
          <td>2</td>
          <td>UPC1</td>
        </tr>
        <tr>
          <td>3</td>
          <td>UPC2</td>
        </tr>
        <tr>
          <td>4</td>
          <td>UPC3</td>
        </tr>
        <tr>
          <td>5</td>
          <td></td>
        </tr>
        <tr>
          <td>6</td>
          <td>Category 2</td>
        </tr>
        <tr>
          <td>7</td>
          <td>UPC4</td>
        </tr>
        <tr>
          <td>8</td>
          <td>UPC5</td>
        </tr>
        <tr>
          <td>9</td>
          <td>UPC6</td>
        </tr>
        <tr>
          <td>10</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  );

  const handleOnDrop = (data, file) => {
    if (errorInfo.error) {
      setErrorInfo({ error: false, message: "" });
    }

    handleChangeImportingData(data, file);
  };

  const handleChangeImportingData = (data, file) => {
    let dataImported = [];

    switch (file.type) {
      case "text/csv":
        data
          .map((item, index) => item.data)
          .forEach((item) => {
            dataImported.push(item[0]);
          });
        setImportedData(dataImported);
        setImportedDataImported(true);

        break;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        readXlsxFile(file).then((data) => {
          data.forEach((item) => {
            dataImported.push(item[0]);
          });
          setImportedData(dataImported);
          setImportedDataImported(true);
        });

        break;
      default:
        setErrorInfo({
          error: true,
          message:
            "The imported file it's not compatible. Please use a .csv or .xlsx file.",
        });
    }
  };

  const importingModalContent = (
    <div className={classes.modal}>
      {!importedDataImported && !finishedFlag ? (
        <>
          In order to successfully import categories and products you must
          create a csv file with the following format:
          <br />
          <br />
          {importingFormat()}
          <br />
          <CSVReader
            onDrop={handleOnDrop}
            accept="text/csv, .csv, .xlsx"
            noDrop
          ></CSVReader>
          <br />
          <div align="right">
            <Button onClick={() => toggleImportingModal()}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              disabled={!importedOrderList.length}
              onClick={() => sendImportingRequest()}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : importedOrderList.length && !loadingFlag ? (
        <>
          The file was processed successfully and the Order Guide contains the
          next categories and items:
          <br />
          <br />
          <div style={{ height: 150, overflow: "auto" }}>
            {importedOrderList.map((item, index) => (
              <Fragment key={`category-${index}`}>
                <b>{item.category_name}: </b>
                {`${item.rows.length} items`}
                <br />
              </Fragment>
            ))}
          </div>
          <br />
          Would you like to replace the Order Guide information with the
          processed data?
          <br />
          <br />
          <div align="right">
            <Button onClick={() => handleClickCancelImporting()}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              disabled={!importedOrderList.length}
              onClick={() => sendImportingRequest()}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Saving Order Guide information <br />
              This may take some time relative to the number of categories and
              items
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while saving the Order Guide information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveOrderListRequest()}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : finishedFlag ? (
        <>
          Order Guide information have been successfully saved
          <br />
          <br />
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveOrderListRequest()}
            >
              Close
            </Button>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );

  const toggleExportingModal = () => {
    setLoadingFlag(false);
    setFinishedFlag(false);
    setExportingModal(!exportingModal);
  };

  const exportingModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Do you want to export the current Order Guide information to a CSV?
          <br />
          <br />
          <b>Note: </b>The exported file is already formatted for you to add
          more categories/products and import it again.
          <br />
          <br />
          <div align="right">
            <Button onClick={() => toggleExportingModal()}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClickExport()}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Exporting Order Guide information <br />
              This may take some time relative to the number of categories and
              fees configured
            </div>
          </div>
          <br />
        </>
      ) : (
        <>
          Order Guide information have been successfully exported
          <br />
          <br />
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => toggleExportingModal()}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const handleClickExport = async () => {
    setLoadingFlag(true);

    const orderListId = categorySettings.orderlist || orderList[0].id;
    const orderListData =
      orderList.find((item) => item.id === categorySettings.orderlist) ||
      orderList[0];

    if (!orderListData.categories.length) {
      setErrorInfo({
        error: true,
        message: "The Order Guide doesn't have any categories.",
      });
    } else {
      let orderListDataExport = [];

      orderListData.categories.forEach((category) => {
        orderListDataExport.push([
          { value: category.category_name, type: String },
        ]);

        category.rows.forEach((row) => {
          orderListDataExport.push([
            { value: "" + row.product_id, type: String },
          ]);
        });

        orderListDataExport.push([{ value: "", type: String }]);
      });

      await writeXlsxFile(orderListDataExport, {
        fileName: `${customer.name}_Order_Guide_${orderListId}_export.xlsx`,
      }).then(() => {
        setLoadingFlag(false);
        setFinishedFlag(true);
      });
    }
  };

  const handleBack = () => {
    props.history.push("/customers");
  };

  const resolveRequest = () => {
    setFinishedFlag(false);
    setLoadingFlag(false);

    toggleConfirmModal();

    if (!errorInfo.error) {
      if (currentUserStore?.is_staff) {
        props.history.push("/customers");
      } else {
        props.history.push("/orders");
      }
    }
  };

  const resolveError = () => {
    setFinishedFlag(false);
    setLoadingFlag(false);
    setErrorInfo({ error: false, message: "" });
    toggleConfirmModal();
  };

  const resolveOrderListRequest = () => {
    setFinishedFlag(false);
    toggleImportingModal();
  };

  const sendRequest = () => {
    setLoadingFlag(true);

    Promise.all(
      orderList.map(async (item) => {
        if (!orderListLoaded) return;

        const categoriesArray = item.categories.map((catItem) => {
          const catRows = catItem.rows.map((row) => ({
            product_id: row.upc || row.product_id,
          }));

          return { category_name: catItem.category_name, rows: catRows };
        });

        let orderListObj = {
          company_location: item.company_location,
          categories: categoriesArray,
        };

        if (item.hasOwnProperty("id")) {
          orderListObj.id = item.id;
          return await backend
            .patch(`${API_URL}orderlists/${orderListObj.id}`, orderListObj)
            .then(({ data }) => {})
            .catch((error) => {
              console.log(error);
              setErrorInfo({
                error: true,
                message: JSON.stringify(error.response.data),
              });
            });
        } else {
          return await backend
            .post(`${API_URL}orderlists/`, orderListObj)
            .then(({ data }) => {})
            .catch((error) => {
              console.log(error);
              setErrorInfo({
                error: true,
                message: JSON.stringify(error.response.data),
              });
            });
        }
      }),
    ).then(() => {
      if (!errorInfo.error) {
        setFinishedFlag(true);
        setLoadingFlag(false);
      }
    });
  };

  const sendImportingRequest = async () => {
    setLoadingFlag(true);
    let orderListObj = {
      id: categorySettings.orderlist || orderList[0].id,
      company_location:
        categorySettings.company_location || orderList[0].company_location,
      categories: importedOrderList,
    };

    await backend
      .patch(`${API_URL}orderlists/${orderListObj.id}`, orderListObj)
      .then(({ data }) => {
        setOrderListLoaded(false);
        setLoadingFlag(false);
        setFinishedFlag(true);
        setImportedDataImported(false);
        setImportedOrderList([]);
      })
      .catch((error) => {
        console.log(error);
        setErrorInfo({
          error: true,
          message: JSON.stringify(error.response.data),
        });
      });
  };

  const handleClickCancelImporting = () => {
    setImportedData([]);
    setImportedDataImported(false);
    setImportedOrderList([]);
    toggleImportingModal();
  };

  const handleChangeProductAuto = useMemo(
    () =>
      debounce(async (e, v) => {
        const validQuery = v !== "" && !v.includes("#") && !v.includes("|");

        if (validQuery) {
          const searchParam = `search=${v}`;

          await backend
            .get(`${API_URL}products?no_page=1&${searchParam}`)
            .then(({ data }) => {
              setProducts(data);
            });
        }
      }, 300),
    [],
  );

  const handleChangeCategorySettings = (e, v) => {
    let { checked, name, value } = e.target;

    if (name === "company_location") {
      filterOrderListPerCompanyLocationSettings(value);
    }

    if (name === "orderlist") {
      filterCategoryListPerCompanyLocationSettings(value);
    }

    if (v && v.hasOwnProperty("upc")) {
      name = "product";
      value = v;
    }

    if (["include_inactive", "include_nonprimary"].includes(name)) {
      value = checked;
    }

    setCategorySettings((prevState) => ({
      ...prevState,
      orderlist: name === "company_location" ? "" : prevState.orderlist,
      category: name === "orderlist" ? "" : prevState.category,
      [name]: value,
    }));
  };

  const filterOrderListPerCompanyLocationSettings = (value) => {
    setOrderListSettings(
      orderList
        .filter((item) => item.company_location === value)
        .map((item) => item.id),
    );
  };

  const filterCategoryListPerCompanyLocationSettings = (value) => {
    const orderListObj = orderList.find((item) => item.id === value);

    const categoryListArray = !orderListObj
      ? []
      : orderListObj.categories.map((item) => item.category_name);

    setCategoryListSettings(categoryListArray);
  };

  const handleChangeCategoryProductAdd = (categorySettings) => {
    setOrderList((prevState) =>
      prevState.map((olItem) => {
        if (olItem.id !== categorySettings.orderlist) return olItem;

        const catArray = olItem.categories.map((cItem) => {
          if (cItem.category_name !== categorySettings.category) return cItem;

          const insertPos = cItem.rows.findIndex((rItem) => {
            if (!rItem.hasOwnProperty("name")) return true;

            const comparison = rItem.name.localeCompare(
              categorySettings.product.name,
            );

            return comparison === -1 ? false : true;
          });

          let rowsArray = [...cItem.rows];

          if (insertPos === -1) {
            rowsArray = [...rowsArray, categorySettings.product];
          } else {
            rowsArray.splice(insertPos, 0, categorySettings.product);
          }

          return { ...cItem, rows: rowsArray };
        });

        const olObj = { ...olItem, categories: catArray };

        return olObj;
      }),
    );

    setCategorySettings((prevState) => ({
      ...prevState,
      category: "",
      product: null,
    }));

    checkProductMissing();
  };

  const handleClickCategoryAdd = () => {
    setOrderList((prevState) =>
      prevState.map((olItem) => {
        if (olItem.id !== categorySettings.orderlist) return olItem;

        const catDisplay = [
          ...olItem.categories,
          { category_name: categorySettings.name, rows: [] },
        ];

        return { ...olItem, categories: catDisplay };
      }),
    );
    setCategorySettings((prevState) => ({
      ...prevState,
      name: "",
      company_location: "",
      orderlist: "",
    }));
  };

  const handleChangeCategory = (e, olId, catIdx) => {
    const { name, value } = e.target;

    setOrderList((prevState) =>
      prevState.map((olItem) => {
        if (olItem.id !== olId) return olItem;

        const categoriesData = olItem.categories.map((catItem, catIndex) => {
          if (catIndex !== catIdx) return catItem;

          return { ...catItem, [name]: value };
        });

        return { ...olItem, categories: categoriesData };
      }),
    );
  };

  const reorderArray = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
  };

  const onDragEndCat = (result) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const orderListId = result.destination.droppableId.replace(
      "orderlist-",
      "",
    );

    const orderListCatArray = orderList.find(
      (item) => item.id === +orderListId,
    ).categories;

    const orderListCatReorder = reorderArray(
      orderListCatArray,
      result.source.index,
      result.destination.index,
    );

    setOrderList((prevState) =>
      prevState.map((item) => {
        if (item.id !== +orderListId) return item;

        return { ...item, categories: orderListCatReorder };
      }),
    );
  };

  const onDragEndProd = (result) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.droppableId === result.source.droppableId) {
      if (result.destination.index === result.source.index) {
        return;
      }

      const [, orderListId, , catIndex] = result.draggableId.split("-");

      const orderListCatProdArray = orderList.find(
        (item) => item.id === +orderListId,
      ).categories[catIndex].rows;

      const orderListCatProdReorder = reorderArray(
        orderListCatProdArray,
        result.source.index,
        result.destination.index,
      );

      setOrderList((prevState) =>
        prevState.map((olItem) => {
          if (olItem.id !== +orderListId) return olItem;

          const olItemCategories = olItem.categories.map(
            (catItem, catItemIndex) => {
              if (catItemIndex !== +catIndex) return catItem;

              return { ...catItem, rows: orderListCatProdReorder };
            },
          );

          return { ...olItem, categories: olItemCategories };
        }),
      );
    } else {
      const [, sourceOrderListId, , sourceCatIndex] =
        result.source.droppableId.split("-");
      const [, destinationOrderListId, , destinationCatIndex] =
        result.destination.droppableId.split("-");

      const sourceOrderListCatProdArray = orderList.find(
        (item) => item.id === +sourceOrderListId,
      ).categories[sourceCatIndex].rows;

      const destinationOrderListCatProdArray = orderList.find(
        (item) => item.id === +destinationOrderListId,
      ).categories[destinationCatIndex].rows;

      const orderlistCatsMove = move(
        sourceOrderListCatProdArray,
        destinationOrderListCatProdArray,
        result.source,
        result.destination,
      );

      setOrderList((prevState) =>
        prevState.map((olItem) => {
          if (+sourceOrderListId !== +destinationOrderListId) {
            if (olItem.id === +sourceOrderListId) {
              const olItemCategories = olItem.categories.map(
                (catItem, catItemIndex) => {
                  if (catItemIndex !== +sourceCatIndex) return catItem;

                  console.log(orderlistCatsMove[result.source.droppableId]);

                  return {
                    ...catItem,
                    rows: orderlistCatsMove[result.source.droppableId],
                  };
                },
              );

              return { ...olItem, categories: olItemCategories };
            } else if (olItem.id === +destinationOrderListId) {
              const olItemCategories = olItem.categories.map(
                (catItem, catItemIndex) => {
                  if (catItemIndex !== +destinationCatIndex) return catItem;

                  console.log(
                    orderlistCatsMove[result.destination.droppableId],
                  );

                  return {
                    ...catItem,
                    rows: orderlistCatsMove[result.destination.droppableId],
                  };
                },
              );

              return { ...olItem, categories: olItemCategories };
            } else {
              return olItem;
            }
          } else {
            const olItemCategories = olItem.categories.map(
              (catItem, catItemIndex) => {
                if (catItemIndex === +sourceCatIndex) {
                  return {
                    ...catItem,
                    rows: orderlistCatsMove[result.source.droppableId],
                  };
                } else if (catItemIndex === +destinationCatIndex) {
                  return {
                    ...catItem,
                    rows: orderlistCatsMove[result.destination.droppableId],
                  };
                } else {
                  return catItem;
                }
              },
            );

            return { ...olItem, categories: olItemCategories };
          }
        }),
      );
    }
  };

  const onDeleteCat = (olIndex, catIndex) => {
    const orderListCatArray = orderList.find(
      (item, index) => index === olIndex,
    ).categories;

    orderListCatArray.splice(catIndex, 1);

    setOrderList((prevState) =>
      prevState.map((item, olIdx) => {
        if (olIdx !== olIndex) return item;

        return { ...item, categories: orderListCatArray };
      }),
    );
  };

  const onDeleteProd = (olIndex, catIndex, prodIndex) => {
    const orderListCatProdArray = orderList.find(
      (item, index) => index === olIndex,
    ).categories[catIndex].rows;

    orderListCatProdArray.splice(prodIndex, 1);

    setOrderList((prevState) =>
      prevState.map((olItem, olIdx) => {
        if (olIdx !== olIndex) return olItem;

        const olItemCategories = olItem.categories.map(
          (catItem, catItemIndex) => {
            if (catItemIndex !== catIndex) return catItem;

            return { ...catItem, rows: orderListCatProdArray };
          },
        );

        return { ...olItem, categories: olItemCategories };
      }),
    );

    checkProductMissing();
  };

  const paginate = (arr, size) => {
    return arr.reduce((acc, val, i) => {
      let idx = Math.floor(i / size);
      let page = acc[idx] || (acc[idx] = []);
      page.push(val);

      return acc;
    }, []);
  };

  useEffect(() => {
    const customerGet = async () => {
      await backend
        .get(`${API_URL}companylocations/${customerId}`)
        .then(({ data }) => {
          setCustomer(data);
          setCustomerLoaded(true);
        });
    };

    if (!isNaN(customerId) && !customerLoaded) {
      customerGet();
    }
  }, [customerId, customerLoaded]);

  const checkProductMissing = () => {
    let productsMissing = false;

    orderList.forEach((item) => {
      item.categories.forEach((catItem) => {
        catItem.rows.forEach((rowItem) => {
          if (rowItem && rowItem.hasOwnProperty("name")) return;

          const productObj = products.find(
            (product) => product.upc === rowItem.product_id,
          );

          if (!productObj) {
            productsMissing = true;
          }
        });
      });
    });

    setOlProductMissing(productsMissing);
  };

  useEffect(() => {
    const getOrderList = async () => {
      await backend
        .get(`${API_URL}orderlists?no_page=1&company_id=${customer.company_id}`)
        .then(({ data }) => {
          setOrderList(data);
          setOrderListLoaded(true);
        });
    };

    const getProducts = async () => {
      let itemsUPC = [];

      orderList.forEach((item) =>
        item.categories.forEach((catItem) =>
          catItem.rows.forEach((rowItem) => {
            itemsUPC.push(rowItem.product_id);
          }),
        ),
      );

      const itemsUPCUnique = [...new Set(itemsUPC)];

      const itemsUPCPag = paginate(itemsUPCUnique, 100);

      let productsArray = [];

      Promise.all(
        itemsUPCPag.map(async (pag) => {
          const productIdStr = pag.join("&upc=");

          return await backend
            .get(
              `${API_URL}products?upc=${productIdStr}&substitution_detail=true&include_inactive=true&include_nonprimary=true&no_page=1`,
            )
            .then(({ data }) => {
              return (productsArray = [...productsArray, ...data]);
            })
            .catch((error) => {
              console.log(error);
              setErrorInfo({
                error: true,
                message: JSON.stringify(error.response.data),
              });
            });
        }),
      ).then((result) => {
        const invalidResult = result.some((item) => item === undefined);

        if (invalidResult) return;

        let productsMissing = false;

        const customerOrderList = orderList.map((item) => {
          const categoriesDisplay = item.categories.map((catItem) => {
            const rowsMapped = catItem.rows.map((rowItem) => {
              const productObj = productsArray.find(
                (product) => product.upc === rowItem.product_id,
              );

              if (!productObj) {
                productsMissing = true;
              }

              return {
                ...rowItem,
                ...productObj,
                mapped:
                  (productObj && productObj.hasOwnProperty("name")) || false,
              };
            });

            return { ...catItem, rows: rowsMapped };
          });

          return {
            ...item,
            categories: categoriesDisplay,
          };
        });

        setOrderList(customerOrderList);
        setOrderListMapped(true);

        if (!productsMissing) {
          setOlProductMissing(false);
        }
      });
    };

    const setDefaultSettings = () => {
      const singleOrderList = orderList.length === 1;

      if (singleOrderList) {
        setOrderListSettings(
          orderList
            .filter((item) => item.company_location === customer.id)
            .map((item) => item.id),
        );

        const orderListObj = orderList.find(
          (item) => item.id === orderList[0].id,
        );

        const categoryListArray = !orderListObj
          ? []
          : orderListObj.categories.map((item) => item.category_name);

        setCategoryListSettings(categoryListArray);

        setCategorySettings((prevState) => ({
          ...prevState,
          company_location: customer.id,
          orderlist: orderList.length ? orderList[0].id : "",
        }));
      }
    };

    if (customer.id !== "" && !orderListLoaded) {
      getOrderList();
    }

    if (orderListLoaded && !orderListMapped) {
      getProducts();
    }

    if (orderListMapped) {
      setDefaultSettings();
    }
  }, [customer, orderList, orderListLoaded, orderListMapped]);

  useEffect(() => {}, [customer, orderList, orderListLoaded]);

  useEffect(() => {
    if (importedDataImported) {
      if (!importedData.length) {
        setErrorInfo({
          error: true,
          message:
            "The imported file couldn't be processed (it didn't generate any data to be imported).",
        });
      } else {
        let categoriesData = [];
        let categoryObj = { category_name: "", rows: [] };
        let resetCategory = false;

        importedData.forEach((item, index) => {
          if (index === 0 || (resetCategory && item !== "")) {
            categoryObj.category_name = item;
            categoryObj.rows = [];
            resetCategory = false;
          } else if (item === "" || item === null) {
            if (categoryObj.category_name !== "") {
              resetCategory = true;

              categoriesData = [...categoriesData, { ...categoryObj }];
              categoryObj = { category_name: "", rows: [] };
            }
          } else {
            if (!item.includes("E+")) {
              categoryObj.rows = [...categoryObj.rows, { product_id: +item }];
            }
          }
        });

        if (!categoriesData.length) {
          setErrorInfo({
            error: true,
            message: "The imported file couldn't be processed.",
          });
        } else {
          setImportedOrderList(categoriesData);
        }
      }
    }
  }, [importedData, importedDataImported]);

  return (
    <Container>
      <Modal open={confirmModal} onClose={toggleConfirmModal}>
        {confirmModalContent}
      </Modal>
      <Modal open={importingModal} onClose={toggleImportingModal}>
        {importingModalContent}
      </Modal>
      <Modal open={exportingModal} onClose={toggleExportingModal}>
        {exportingModalContent}
      </Modal>
      {currentUserStore?.is_staff === true && (
        <Stack direction="row" spacing={1} justifyContent="center">
          <Link to={`/customer/${customerId}`}>
            <Button variant="contained" color="inherit">
              <Typography variant="subtitle2" color="black">
                Customer Location
              </Typography>
            </Button>
          </Link>
          <Button variant="contained" color="primary">
            <Typography variant="subtitle2" className="text-white">
              Order Guide
            </Typography>
          </Button>
          <Link to={`/customer/${customerId}/fees`}>
            <Button variant="contained" color="inherit">
              <Typography variant="subtitle2" color="black">
                Fees
              </Typography>
            </Button>
          </Link>
        </Stack>
      )}
      <Typography component="h6" variant="h6" className="page-title">
        {`${customerId ? "Edit" : "Add"} ${customer.name || ""}`} Order Guide
      </Typography>
      {!orderListMapped ? (
        <div align="center">
          <br />
          <CircularProgress />
          <div>
            Loading products <br />
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while getting products information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {!errorInfo.message.includes("<html") && errorInfo.message}
              </span>
              {errorInfo.message.includes("<html") && (
                <div style={{ overflow: "scroll", width: 1080, height: 300 }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: JSON.parse(errorInfo.message),
                    }}
                  />
                </div>
              )}
            </>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <>
          <Typography style={{ marginBottom: "16px", color: "#666" }}>
            Manage categories and products for your Order Guide
          </Typography>
          <Stack
            direction="row"
            spacing={0}
            justifyContent="center"
            className="tabs-container"
          >
            <Button
              {...(orderListNav !== 0
                ? { onClick: () => setOrderListNav(0) }
                : undefined)}
              sx={{
                color: orderListNav === 0 ? "primary.main" : "#999",
                fontWeight: orderListNav === 0 ? 600 : 400,
                fontSize: "0.95rem",
                textTransform: "none",
                borderRadius: 0,
                borderBottom:
                  orderListNav === 0 ? "3px solid" : "3px solid transparent",
                borderColor:
                  orderListNav === 0 ? "primary.main" : "transparent",
                paddingBottom: "12px",
                paddingTop: "8px",
                paddingX: "20px",
                marginBottom: "-2px",
                minWidth: "120px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "transparent",
                  color: orderListNav === 0 ? "primary.main" : "#666",
                },
              }}
              className="categories-tab"
            >
              Categories
            </Button>
            <Button
              {...(orderListNav !== 1
                ? { onClick: () => setOrderListNav(1) }
                : undefined)}
              sx={{
                color: orderListNav === 1 ? "primary.main" : "#999",
                fontWeight: orderListNav === 1 ? 600 : 400,
                fontSize: "0.95rem",
                textTransform: "none",
                borderRadius: 0,
                borderBottom:
                  orderListNav === 1 ? "3px solid" : "3px solid transparent",
                borderColor:
                  orderListNav === 1 ? "primary.main" : "transparent",
                paddingBottom: "12px",
                paddingTop: "8px",
                paddingX: "20px",
                marginBottom: "-2px",
                minWidth: "120px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "transparent",
                  color: orderListNav === 1 ? "primary.main" : "#666",
                },
              }}
              className="products-tab"
            >
              Products
            </Button>
          </Stack>
          {orderListNav === 0 ? (
            <OrderlistCategories
              {...props}
              categorySettings={categorySettings}
              customer={customer}
              orderList={orderList}
              orderListSettings={orderListSettings}
              handleChangeCategory={handleChangeCategory}
              handleChangeCategorySettings={handleChangeCategorySettings}
              handleClickCategoryAdd={handleClickCategoryAdd}
              onDragEnd={onDragEndCat}
              onDelete={onDeleteCat}
              toggleImportingModal={toggleImportingModal}
              toggleExportingModal={toggleExportingModal}
            />
          ) : (
            <OrderlistProducts
              {...props}
              categorySettings={categorySettings}
              customer={customer}
              orderList={orderList}
              orderListSettings={orderListSettings}
              categoryListSettings={categoryListSettings}
              handleChangeProductAuto={handleChangeProductAuto}
              handleChangeCategorySettings={handleChangeCategorySettings}
              handleChangeCategoryProductAdd={handleChangeCategoryProductAdd}
              onDragEnd={onDragEndProd}
              onDelete={onDeleteProd}
              toggleImportingModal={toggleImportingModal}
              toggleExportingModal={toggleExportingModal}
              products={products}
              olProductMissing={olProductMissing}
            />
          )}
          <br />
          <Stack direction="row" spacing={1} justifyContent="right">
            <Button onClick={handleBack}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => toggleConfirmModal()}
              className="save-button"
            >
              Save
            </Button>
          </Stack>
        </>
      )}
    </Container>
  );
};

export default CustomerOrderlists;
